import { useCallback } from "react";

import { API_USERS, BASE_ADMIN } from "../constants/api";
import { UsersListType } from "../types/user";
import { canManageUsers } from "../utils/roles";
import useRequest from "./useRequest";
import useAuth from "./useAuth";

const useLastUsers = () => {
  const {user} = useAuth();
  const canAccess = canManageUsers(user?.role);
  
  const {
    error,
    isLoading,
    response,
    request
  } = useRequest<UsersListType>();

  const fetchLastUsers = useCallback(() => {
    if (!canAccess) return;

    const searchParams = {
      page: "1",
      limit: "4",
      orderby: "createdAt",
      order: "DESC"
    }
    request(BASE_ADMIN, `${API_USERS}`, {secure: true, searchParams});
  }, [canAccess, request]);

  return {isLoading, error, lastUsers: response ? response.data : null, fetchLastUsers}


}
export default useLastUsers;